import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ServicePageLayout from "../components/ServicePageLayout";
import { useGuestSession } from "contexts/GuestSessionContext";

import { LUXURY } from "data/guestLuxuryTheme";

const statusColor = (status) => {
  if (status === "cancelled") return "#94a3b8";
  if (status === "confirmed") return "#0f766e";
  return "#c2410c";
};

const RequestsPage = () => {
  const navigate = useNavigate();
  const { requests, cancelRequest, companyId } = useGuestSession();

  return (
    <ServicePageLayout
      title="My requests"
      subtitle="Food orders and room requests from this phone stay here until you leave."
      illustration="requests"
    >
      {requests.length === 0 ? (
        <Box
          sx={{
            p: 3,
            borderRadius: "18px",
            bgcolor: LUXURY.cardLight,
            textAlign: "center",
            border: `1px solid ${LUXURY.surfaceBorder}`,
          }}
        >
          <Typography sx={{ fontWeight: 700, wordBreak: "break-word", color: LUXURY.surfaceInk }}>
            Nothing yet
          </Typography>
          <Typography
            sx={{ color: LUXURY.surfaceHint, mt: 0.5, lineHeight: 1.5, wordBreak: "break-word" }}
          >
            Orders and towels, laundry, or help requests will show up here.
          </Typography>
        </Box>
      ) : (
        <Stack spacing={1.25}>
          {requests.map((item) => (
            <Box
              key={item.id}
              sx={{
                p: 2,
                borderRadius: "18px",
                bgcolor: LUXURY.cardLight,
                border: `1px solid ${LUXURY.surfaceBorder}`,
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 800,
                      lineHeight: 1.3,
                      wordBreak: "break-word",
                      color: LUXURY.surfaceInk,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: LUXURY.surfaceHint,
                      fontSize: "0.82rem",
                      mt: 0.35,
                      lineHeight: 1.4,
                      wordBreak: "break-word",
                    }}
                  >
                    {item.details || item.locationLabel}
                  </Typography>
                  <Typography
                    sx={{
                      color: LUXURY.surfaceMuted,
                      fontSize: "0.72rem",
                      mt: 0.5,
                      wordBreak: "break-word",
                    }}
                  >
                    {new Date(item.createdAt).toLocaleString()}
                  </Typography>
                </Box>
                <Chip
                  size="small"
                  label={item.status}
                  sx={{ fontWeight: 800, color: statusColor(item.status), flexShrink: 0, textTransform: "capitalize" }}
                />
              </Stack>
              <Stack direction="row" spacing={1} sx={{ mt: 1.25 }}>
                {item.type === "food" && item.orderId ? (
                  <Button
                    size="small"
                    onClick={() =>
                      navigate(
                        `/track-order/${item.orderId}?companyId=${encodeURIComponent(companyId || "")}`
                      )
                    }
                    sx={{ fontWeight: 800, color: LUXURY.goldDeep }}
                  >
                    Track order
                  </Button>
                ) : null}
                {item.status !== "cancelled" && item.type !== "food" ? (
                  <Button
                    size="small"
                    onClick={() => cancelRequest(item.id)}
                    sx={{ color: LUXURY.surfaceMuted }}
                  >
                    Cancel
                  </Button>
                ) : null}
              </Stack>
            </Box>
          ))}
        </Stack>
      )}
    </ServicePageLayout>
  );
};

export default RequestsPage;
